import React, { useEffect, useState } from "react";
import { getRouteAndRateList } from "../../api/api";
import { numberOnly } from "../Utils/Helper";

function ViewRateListPopup(props) {
  const [routeAndrateList, setRouteAndrateList] = useState([]);
  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  useEffect(() => {
    if (!props.selectedSystemID) return;

    getRouteAndRateList(props.selectedSystemID).then((res) => {
      if (res.data.success === true) {
        setRouteAndrateList(res.data.data);
        seterror({ errarStatus: false, errorMessage: "", bgcolor: "" });
      } else {
        setRouteAndrateList([]);
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
      }
    });
  }, [props.selectedSystemID]);

  return (
    <div
      className="modal fade"
      id="viewRateListModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="viewRateListModalTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="viewRateListModalTitle">
              Route and Rate List of{" "}
              <span className="text-success">{props.selectedSystemID} </span>
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {error.errarStatus ? (
              <div className={error.bgcolor} role="alert">
                <strong>Alert!</strong> {error.errorMessage}
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            ) : null}
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Sender ID</th>
                    <th>System ID</th>
                    <th>Price</th>
                    <th>Country Code</th>
                    <th>Route</th>
                  </tr>
                </thead>
                <tbody>
                  {routeAndrateList.map((items, i) => (
                    <tr key={i}>
                      <td>{items.source_regex}</td>
                      <td>{items.system_id}</td>
                      <td>{items.cost}</td>
                      <td>
                        {items.country_name}({numberOnly(items.regex)})
                      </td>
                      <td>{items.smsc_id}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewRateListPopup;
